import { PuLangFetch, PuLangFetchInstance } from '~/lang/utils/pulangfetch'
import { bindDependencies } from '~/utility/inversify'
import { keysToCamel } from '~/utility/toCamel'

const getCsrfToken = async (puLangFetch: PuLangFetchInstance) => {
  return keysToCamel(
    await puLangFetch.fallbackFetch(
      'en-gb',
      `/accounts/ping/?domain=${puLangFetch.getDomainName()}`,
    ),
  )
}

export const csrfTokenService = () => {
  return bindDependencies(getCsrfToken, [PuLangFetch])()
}
